var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenEyeIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 2.92499C3.15 2.92499 0 7.19999 0 8.99999C0 10.8 3.15 15.075 9 15.075C14.85 15.075 18 10.8 18 8.99999C18 7.19999 14.85 2.92499 9 2.92499ZM9 13.95C3.6 13.95 1.125 9.89999 1.125 8.99999C1.125 8.09999 3.7125 4.04999 9 4.04999C14.2875 4.04999 16.875 8.09999 16.875 8.99999C16.875 9.89999 14.4 13.95 9 13.95Z",
    fill: "#00AEEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99985 5.28748C6.97485 5.28748 5.28735 6.97498 5.28735 8.99998C5.28735 11.025 6.97485 12.7125 8.99985 12.7125C11.0249 12.7125 12.7124 11.025 12.7124 8.99998C12.7124 6.97498 11.0249 5.28748 8.99985 5.28748ZM8.99985 11.7C7.53735 11.7 6.29985 10.4625 6.29985 8.99998C6.29985 7.53748 7.53735 6.29998 8.99985 6.29998C10.4624 6.29998 11.6999 7.53748 11.6999 8.99998C11.6999 10.4625 10.4624 11.7 8.99985 11.7Z",
    fill: "#00AEEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenEyeIcon);
export default __webpack_public_path__ + "static/media/open-eye-icon.ed4d60bef88077755caa89f77b1ac603.svg";
export { ForwardRef as ReactComponent };